// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { createContext } from 'react'

const AuthContext = createContext()

export default AuthContext
